module.exports = __webpack_public_path__ + "img/logo-sm-light.631ff51b.png";